<template>
  <div class="time-codes-component">
    <h1 class="page-title">{{ $t('TimeCodes.title_page') }}</h1>

    <div v-if="entities && entities.length > 1">
      <select-entity :entities="entities" :preselected-entity-id="entityId" v-on:entity-changed="onChangeEntityId"></select-entity>
    </div>

    <div v-if="entityId">
      <div class="row">
        <div class="col-6 col-md-3 p-b-15">
          <router-link :to="{ name: 'NewTimeCode', params: { entity_id: entityId }}" class="btn btn-secondary btn-block btn-cons">{{ $t("buttons.add") }}</router-link>
        </div>
      </div>

      <time-codes-table :entity-id="entityId"></time-codes-table>
    </div>

  </div>
</template>

<script>
  import TimeCodesTable from './TimeCodesTable'
  import NewTimeCode from './NewTimeCode'
  import NoData from '../common/NoData'
  import SelectEntity from '../common/SelectEntity'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TimeCodes',
    components: {
      TimeCodesTable,
      NewTimeCode,
      SelectEntity
    },
    data() {
      return {
        currentEntity: null
      }
    },
    computed: {
      ...mapGetters({
        entities: 'auth/entities',
        entityId: 'auth/currentEntityId'
      })
    },
    methods: {
      onChangeEntityId: function(value) {
        if(this.entityId != value.id) {
          this.$store.dispatch('auth/setCurrentEntityId', value.id)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/timeCodes/TimeCodes.vue